<script setup lang="ts">
import { useFetchGeneral } from '~/api/service/general/index.service'
import HomeCardTitle from '~/components/@pages/home/HomeCardTitle.vue'
import HomeChartTitle from '~/components/@pages/home/HomeChartTitle.vue'
import LineChart from '~/components/chart/LineChart.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import IconTooltip from '~/components/tooltip/IconTooltip.vue'
import { HOME_CHART_TOOLTIP, HOME_REFETCH_PARAMS } from '~/constants/general.const'
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { generalParamType } from '~/types/general.type'
import { setComma } from '~/utils/numberFormat'

const { data, isLoading } = useFetchGeneral([ generalParamType.NORMAL_TRANSACTION ])
const { data: countData, isLoading: countLoading } = useFetchGeneral(HOME_REFETCH_PARAMS)

const totalCount = computed(() => {
  if (!countData.value) return ''
  return setComma(countData.value.FNTTCNTI.OBJ.TTRXCNT)
})

const lineChartList = computed(() => {
  if (!data.value) return []
  return data.value.FNTI.OBJ.DTRXLIST.map(i => {
    return [ i.UT, i.TRXCNT ]
  })
})
</script>

<template>
  <div>
    <CustomSuspense :is-loading="isLoading || countLoading">
      <template #loading>
        <img
          :src="`${IMAGE_BASE_URL}/skeleton/home/line-chart.png`"
          alt="line chart skeleton"
        >
      </template>
      <template #default>
        <Card class="flex flex-col justify-start gap-y-8 pt-5">
          <HomeCardTitle class="px-5">
            <div class="flex items-center gap-x-1">
              Daily Transaction (Avg)
              <IconTooltip :tooltip="HOME_CHART_TOOLTIP[generalParamType.NORMAL_TRANSACTION]" />
              :
              <strong class="font-normal text-primary">{{
                setComma(data.FNTI.OBJ.DAVGTRXC)
              }}</strong><span> txns</span>
            </div>
          </HomeCardTitle>
          <div class="flex flex-col gap-y-2 px-5">
            <HomeChartTitle
              title="Total Transactions"
              :tooltip="HOME_CHART_TOOLTIP[generalParamType.NORMAL_TRANSACTION_TOTAL_COUNT]"
            />
            <strong class="text-3xl text-primary">{{ totalCount }}</strong>
          </div>
          <LineChart
            :height="136"
            :data="lineChartList"
            :formatter="(params) => {
              return `<p class='text-center'><span class='text-primary/40'>${params[0].name}</span><br />Transactions: ${setComma(params[0].value)}</p>`
            }"
          />
        </Card>
      </template>
    </CustomSuspense>
  </div>
</template>

<style scoped lang="scss">
</style>